module team {
  'use strict';

  

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class TeamCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$location',
      '$anchorScroll', 
      '$http',
      '$element',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: ITeamScope,
      private $location: ng.ILocationService,
      private $anchorScroll: any, //ng.IAnchorScrollService
      private $http: ng.IHttpService, //angular.animate.IAnimateService,
      private $element: JQuery
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;

      var elData :JQuery = $element;
      var maxDepth = 10;
      while (maxDepth > 0 && elData.parent() && !elData.data('route-id')) {
        elData = elData.parent();
        maxDepth--;
      }

      var id : string = elData.data('route-id');
  
      this.$http<Person[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Team/List/" + id
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
        , data: {
        }
      }).then((response : {data: Person[] }) => {
        $scope.persons = response.data;
      });

    }

    

  }

}